import { NotifyHelper } from "../../../helpers/toast";
import { eBienLaiViewTheoLopChiTietActionsObj } from "../../action-types/bien-lai/IBienLaiViewTheoLopChiTietActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";

export const bienLaiViewTheoLopChiTietActions = {
  ...generateActions(
    eBienLaiViewTheoLopChiTietActionsObj,
    "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET"
  ),
  ...generateActionForKey(
    eBienLaiViewTheoLopChiTietActionsObj,
    "BIEN_LAI_VIEW_THEO_LOP_CHI_TIET",
    "PRINT_ERR",
    (m) => {
      NotifyHelper.Error(m.data);
    }
  ),
};
